// Утилита для форматирования даты из dayjs в строку формата 'YYYY-MM-DD' или переданного формата

import type { Dayjs } from 'dayjs';

export const formatDayjsToString = (
  date: Dayjs | null,
  format = 'YYYY-MM-DD'
): string | null => (date?.isValid() ? date.format(format) : null);
